import PropTypes from 'prop-types';
import { noop } from '../../../utils/noop';
import { formInputStyles } from './FormInput.style';

const FormInput = ({
  type,
  errorText,
  onChange,
  placeholder,
  id,
  onBlur,
  viewIcon,
  onIconClick,
  iconName,
  showLabel,
  className,
}) => (
  <div className="textfield-wrapper">
    {showLabel && <label htmlFor={id}>{placeholder}</label>}
    <input
      type={type}
      id={id}
      onChange={onChange}
      placeholder={placeholder}
      onBlur={onBlur}
      className={`${className} ${errorText && 'error-input'}`}
    />
    {errorText && <p className="error">{errorText}</p>}
    {viewIcon && (
      <button type="button" className="reveal-btn" id="testId-LoginForm-eye" onClick={onIconClick}>
        <i className={`form-icon ${iconName}`} />
      </button>
    )}
    <style jsx>{formInputStyles}</style>
  </div>
);

FormInput.defaultProps = {
  onIconClick: noop,
  iconName: '',
  viewIcon: false,
  onBlur: noop,
  showLabel: true,
  className: '',
};

FormInput.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  viewIcon: PropTypes.bool,
  onIconClick: PropTypes.func,
  iconName: PropTypes.string,
  showLabel: PropTypes.bool,
  className: PropTypes.string,
};

export { FormInput };
